exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".td-acciones[data-v-52840861]{white-space:nowrap}.td-acciones input[data-v-52840861]{max-width:80px;text-align:center}.td-click[data-v-52840861]{cursor:pointer}", "", {"version":3,"sources":["D:/laragon/www/sima/simaapp-web/src/components/views/compras/TablaCompra.vue"],"names":[],"mappings":"AACA,8BACE,kBAAoB,CACrB,AACD,oCACE,eAAgB,AAChB,iBAAmB,CACpB,AACD,2BACE,cAAgB,CACjB","file":"TablaCompra.vue","sourcesContent":["\n.td-acciones[data-v-52840861] {\r\n  white-space: nowrap;\n}\n.td-acciones input[data-v-52840861] {\r\n  max-width: 80px;\r\n  text-align: center;\n}\n.td-click[data-v-52840861] {\r\n  cursor: pointer;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-52840861","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/compras/TablaCompra.vue
// module id = 395
// module chunks = 1